import { render, staticRenderFns } from "./OwnerReservationSetup.vue?vue&type=template&id=ea37d868&scoped=true&"
import script from "./OwnerReservationSetup.vue?vue&type=script&lang=js&"
export * from "./OwnerReservationSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea37d868",
  null
  
)

export default component.exports